<div class="table-responsive" *ngIf="data!=null&&data.data!=null;else loading_box">
    <table class="table datatables-ajax">
        <thead class="table-header-dark-light">
            <tr class="table-light">
                <th scope="col" class="side-column px-1"> # </th>
                <th scope="col" class="sortable" *ngFor="let header of tableHeader">
                    <div class="header-box">
                        <span>
                            {{ header | translate}}
                        </span>
                        <button type="button" class="btn btn-label-secondary btn-icon" *ngIf="data.sorable"
                            (click)="callParent(header,'Sort')">
                            <i [ngClass]="{'bx bx-sort-alt-2' : data.sortingColumnName != header,
                                'fas fa-sort-alpha-down': data.sortingColumnName === header&&data.direction==='asd',
                                'fas fa-sort-alpha-up' : data.sortingColumnName === header&&data.direction==='desc'
                             }">
                            </i>
                        </button>
                    </div>
                </th>
                <th scope="col" class="side-column px-1"> &nbsp; </th>
            </tr>
        </thead>
        <tbody class="table-body-dark-light">
            <tr *ngFor="let row of data.data;let i=index;"
              [ngClass]="{'keyboard-focus': focusRow === i,'midPaid':row['paidState'] === 100 ,'completePaid':row['paidState'] === 200}">
                <td scop="row" class="side-column px-1">
                    {{ i + data.startIndex }}
                </td>

                <td *ngFor="let cell of tableHeader">
                    <i [ngClass]="setBooleanClass(row[cell])" *ngIf="checkBoolean(row[cell])"></i>
                    {{ row[cell] | dataType : cell}}
                </td>

                <td class="side-column px-1">
                    <div class="btn-group" style="position: unset;">
                        <button type="button" *ngFor="let item of data.rowButtoms" class="btn btn-icon"
                            [ngClass]="item.className" (click)="callParent(row,item.name)">
                            <i [ngClass]="item.icon">
                            </i>
                        </button>

                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<ng-template #loading_box>
    <div class="table-responsive">
        <table class="table datatables-ajax">
            <thead class="table-header-dark-light">
                <tr class="table-light">
                    <th scope="col" class="sortable">
                        &#160;
                    </th>
                </tr>
            </thead>
            <tbody class="table-body-dark-light">
                <td colspan="500">
                    <div class="app-loading loading-table"></div>
                </td>
            </tbody>
        </table>
    </div>
</ng-template>


